/* globals $:false */
/* globals console:false */

(function () {
    'use strict';

    $(document).ready(function () {
        let contactForm = $('.form-container');
        let contactButton = $('.submit-container button');
        let contactError = $('#contact-form-error');

        contactForm.on('submit', function (event) {
            event.preventDefault();

            // Clear previous errors
            contactError.addClass('hide');
            $('.error').removeClass('error');

            let data = {
                first_name: $('#first-name').val(),
                last_name: $('#last-name').val(),
                company: $('#company').val(),
                position: $('#position').val(),
                email: $('#email').val(),
                phone: $('#phone').val(),
                country: $('#country').val(),
                message: $('#message').val()
            };

            // Basic validation
            let requiredFields = ['first_name', 'last_name', 'email', 'phone', 'country', 'message'];
            let isValid = true;

            requiredFields.forEach(function (field) {
                let element = $('[name="' + field + '"]');
                if (!data[field]) {
                    element.parent().addClass('error');
                    isValid = false;
                }
            });

            if (!isValid) {
                contactError.text('Please fill in all required fields.').removeClass('hide');
                return;
            }

            contactButton.prop('disabled', true).text('Sending...');

            $.ajax('/contact', {
                data: JSON.stringify(data),
                contentType: 'application/json',
                type: 'POST',
                success: function (response) {
                    if (response === true) {
                        $('#contact-form-section').addClass('hide');
                        $('#contact-success-section').removeClass('hide');
                        // Scroll to top of the success section
                        $('html, body').animate({
                            scrollTop: $("#contact-success-section").offset().top - 100
                        }, 500);
                    } else {
                        contactError.text('Something went wrong. Please try again.').removeClass('hide');
                        contactButton.prop('disabled', false).text('Contact For First Looks Program');
                    }
                },
                error: function (xhr) {
                    let errorMessage = 'Failed to send message. Please try again later.';
                    if (xhr.status === 400) {
                        errorMessage = 'Invalid form data. Please check all fields.';
                    }
                    contactError.text(errorMessage).removeClass('hide');
                    contactButton.prop('disabled', false).text('Contact For First Looks Program');
                }
            });
        });

        // Add focus handlers to remove error class
        $('input, select, textarea').on('focus', function () {
            $(this).parent().removeClass('error');
            // Optionally hide error message when user starts typing again
            // contactError.addClass('hide'); 
        });
    });
}());
